import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type FacebookGroup = {
  id: string;
  group_name: string;
  admin_name: string;
  email: string;
  facebook_url: string;
  description: string | null;
  member_count: string | null;
  group_type: string | null;
  topics: string | null;
  location: string | null;
  image_url: string | null;
  approved: boolean;
  featured: boolean;
  status: "pending" | "approved" | "rejected";
  created_at: string;
};

export type Creator = {
  id: string;
  creator_name: string;
  business_name: string;
  email: string;
  website: string | null;
  location: string | null;
  type: string | null;
  specialty: string;
  categories: string | null;
  bio: string | null;
  instagram: string | null;
  etsy: string | null;
  how_heard: string | null;
  featured: boolean;
  approved: boolean;
  rating: number;
  product_count: number;
  image_url: string | null;
  status: "pending" | "approved" | "rejected";
  created_at: string;
};
